import { Reducer } from 'interfaces'
import { CreditCardDataState } from 'components/features/creditCard/creditCardStore/state'
import { CCOnboardingInitiateAction, GetCCOnboardingStateAction, PatchCCOnboardingPropsAction } from 'components/features/creditCard/creditCardStore/actions'
import { WsMessageAction } from 'actions/webSocketActions'

export const ccPersonDataReducer: Reducer<CreditCardDataState['person_data']> = (prevState = null, action) => {
  switch (action.type) {
    case WsMessageAction.type: {
      if (action.payload.event !== 'credit_card_onboarding_changed') {
        return prevState
      }

      return action.payload.data.onboarding.person_data
    }

    case CCOnboardingInitiateAction.type:
    case PatchCCOnboardingPropsAction.type:
    case GetCCOnboardingStateAction.type: {
      if (action.meta !== 'success') {
        return prevState
      }

      return action.payload.response.person_data
    }
  }
  return prevState
}
